{
  "pages": [
    {
      "name": "Hot Water Tank",
      "elements": [
        {
          "type": "panel",
          "name": "Hot Water Tank for Domestic Hot Water production",
          "elements": [
            {
              "type": "text",
              "name": "title",
              "title": "System name"
            },
            {
              "type": "boolean",
              "name": "Control_enabled",
              "title": "Control of hot water tank enabled?",
              "labelTrue": "Yes",
              "labelFalse": "No",
              "isRequired": true
            },
            {
              "type": "boolean",
              "name": "P_hasPump",
              "title": "Is there a pump?",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            }
          ],
          "title": "Hot water tank info",
          "isRequired": true
        },
        {
          "type": "panel",
          "name": "Heat Exchanger for Domestic Hot Water production",
          "elements": [
            {
              "type": "boolean",
              "name": "HM_present",
              "title": "Heat meter needed?",
              "labelTrue": "Yes",
              "labelFalse": "No",
              "isRequired": true
            },
            {
              "type": "dropdown",
              "name": "HM_location",
              "visibleIf": "{HM_present} = true",
              "title": "Where is the heat meter placed?",
              "isRequired": true,
              "choices": [
                {
                  "value": "PrimaryForward",
                  "text": "Forward"
                },
                {
                  "value": "PrimaryReturn",
                  "text": "Return"
                }
              ]
            },
            {
              "type": "text",
              "name": "HM_address",
              "visibleIf": "{HM_present} = true",
              "isRequired": true,
              "title": "Bus address",
              "inputType": "number"
            }
          ],
          "title": "Heat Meter",
          "isRequired": true
        },
        {
          "type": "panel",
          "name": "panel7",
          "visibleIf": "{P_hasPump} = true",
          "elements": [
            {
              "type": "dropdown",
              "name": "P_type",
              "title": "Type",
              "isRequired": true,
              "choices": [
                {
                  "value": "Magna3",
                  "text": "MAGNA3"
                },
                {
                  "value": "TPE",
                  "text": "TPE"
                },
                {
                  "value": "TPE2",
                  "text": "TPE2"
                },
                {
                  "value": "TPE3",
                  "text": "TPE3"
                },
                {
                  "value": "Alpha",
                  "text": "ALPHA"
                },
                {
                  "value": "UPS",
                  "text": "UPS"
                },
                {
                  "value": "Pump",
                  "text": "Other"
                }
              ]
            },
            {
              "type": "boolean",
              "name": "P_connected",
              "visibleIf": "{P_type} = \"Magna3\" or {P_type} = \"TPE\" or {P_type} = \"TPE2\" or {P_type} = \"TPE3\"",
              "title": "Enable pump connectivity?",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "text",
              "name": "P_address",
              "visibleIf": "{P_connected} = true",
              "isRequired": false,
              "title": "Bus address",
              "inputType": "number"
            }
          ],
          "title": "Pump"
        },
        {
          "type": "panel",
          "name": "Sensors",
          "elements": [
            {
              "type": "boolean",
              "name": "T_PF_present",
              "visibleIf": "{HM_present} = false",
              "title": "Primary supply side temperature",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_PR_present",
              "visibleIf": "{HM_present} = false",
              "title": "Primary side return temperature",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_SR_present",
              "title": "Secondary side return temperature",
              "visibleIf": "{P_connected} != true",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_MIDDLE_present",
              "title": "Tank middle temperature",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "boolean",
              "name": "T_BOTTOM_present",
              "title": "Tank bottom temperature",
              "labelTrue": "Yes",
              "labelFalse": "No"
            }
          ],
          "title": "Temperature Sensors"
        },
        {
          "type": "panel",
          "name": "panel5",
          "elements": [
            {
              "type": "boolean",
              "name": "Q_SC_present",
              "title": "Flow meter of cold water supply on secondary side",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "text",
              "name": "Q_SC_address",
              "visibleIf": "{Q_SC_present} = true",
              "isRequired": true,
              "title": "Flow meter address",
              "inputType": "number"
            }
          ],
          "title": "Flow Meter"
        },
        {
          "type": "panel",
          "name": "panel10",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_PF_sensortype",
              "isRequired": true,
              "visibleIf": "{T_PF_present} == true",
              "title": "Type",
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "visibleIf": "{T_PF_present} == true",
          "title": "Primary side supply temperature sensor details"
        },
        {
          "type": "panel",
          "name": "panel11",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_PR_sensortype",
              "visibleIf": "{T_PR_present} == true",
              "title": "Type",
              "isRequired": true,
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "visibleIf": "{T_PR_present} == true",
          "title": "Primary side return temperature sensor details"
        },
        {
          "type": "panel",
          "name": "panel2",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_T_sensortype",
              "title": "Type",
              "isRequired": true,
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "title": "Tank top temperature sensor details"
        },
        {
          "type": "panel",
          "name": "T_MIDDLE-details",
          "title": "Tank middle sensor details",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_MIDDLE_sensortype",
              "isRequired": true,
              "title": "Type",
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "visibleIf": "{T_MIDDLE_present} == true"
        },
        {
          "type": "panel",
          "name": "T_BOTTOM-details",
          "title": "Tank bottom sensor details",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_BOTTOM_sensortype",
              "isRequired": true,
              "title": "Type",
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "visibleIf": "{T_BOTTOM_present} == true"
        },
        {
          "type": "panel",
          "name": "panel4",
          "elements": [
            {
              "type": "dropdown",
              "name": "T_SR_sensortype",
              "isRequired": true,
              "title": "Type",
              "choices": [
                {
                  "value": "SensorPT100",
                  "text": "PT100"
                },
                {
                  "value": "SensorPT500",
                  "text": "PT500"
                },
                {
                  "value": "SensorPT1000",
                  "text": "PT1000"
                },
                {
                  "value": "NTC10K",
                  "text": "NTC 10k"
                },
                {
                  "value": "NTC1K8Schneider",
                  "text": "Schneider NTC 1.8k"
                },
                {
                  "value": "SensorNI100",
                  "text": "Ni100"
                },
                {
                  "value": "SensorNI1000_TK5000",
                  "text": "Ni1000 TK5000"
                },
                {
                  "value": "SensorNI1000_TK6180",
                  "text": "Ni1000 TK6180"
                }
              ]
            }
          ],
          "visibleIf": "{T_SR_present} == true",
          "title": "Secondary return temperature sensor details"
        },
        {
          "type": "panel",
          "name": "pnlControlValve",
          "elements": [
            {
              "type": "dropdown",
              "name": "MV_positionControl",
              "visibleIf": "{Control_enabled} = true",
              "title": "Valve position control",
              "isRequired": true,
              "choices": [
                {
                  "value": "ModulatingControl",
                  "text": "Modulating"
                },
                {
                  "value": "ThreePointControl",
                  "text": "3-point control"
                },
                {
                  "value": "ModbusRtuControl",
                  "text": "MODBUS RTU"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "MV_ModbusRtuProfile",
              "visibleIf": "{MV_positionControl} = \"ModbusRtuControl\"",
              "title": "Profile",
              "isRequired": true,
              "choices": [
                {
                  "text": "Belimo Energy Valve EV#R1+(K)BAC",
                  "value": "BelimoEnergyValveProfile_EV_RPlus_Bac"
                },
                {
                  "text": "Belimo Energy Valve EV#R2+(K)BAC",
                  "value": "BelimoEnergyValveProfile_EV_R2Plus_Bac"
                }
              ]
            },
            {
              "type": "text",
              "name": "MV_ModbusRtuAddress",
              "visibleIf": "{MV_positionControl} = \"ModbusRtuControl\"",
              "isRequired": true,
              "title": "MODBUS address",
              "inputType": "number"
            },
            {
              "type": "boolean",
              "name": "MV_overrideDefaultModbusRtuSettings",
              "visibleIf": "{MV_positionControl} = \"ModbusRtuControl\"",
              "title": "Override default MODBUS RTU settings?",
              "isRequired": false,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "dropdown",
              "name": "MV_ModbusRtuBaudRate",
              "visibleIf": "{MV_positionControl} = \"ModbusRtuControl\" and MV_overrideDefaultModbusRtuSettings = true",
              "title": "Baud rate",
              "isRequired": true,
              "choices": [
                {
                  "value": "Baud9600",
                  "text": "9600"
                },
                {
                  "value": "Baud19200",
                  "text": "19200"
                },
                {
                  "value": "Baud38400",
                  "text": "38400"
                },
                {
                  "value": "Baud76800",
                  "text": "76800"
                },
                {
                  "value": "Baud115200",
                  "text": "115200"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "MV_ModbusRtuTransmissionFormat",
              "visibleIf": "{MV_positionControl} = \"ModbusRtuControl\" and MV_overrideDefaultModbusRtuSettings = true",
              "title": "Transmission formats",
              "isRequired": true,
              "choices": [
                {
                  "value": "1-8-N-2",
                  "text": "1-8-N-2"
                },
                {
                  "value": "1-8-N-1",
                  "text": "1-8-N-1"
                },
                {
                  "value": "1-8-E-1",
                  "text": "1-8-E-1"
                },
                {
                  "value": "1-8-O-1",
                  "text": "1-8-O-1"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "MV_actuatorPower",
              "visibleIf": "{MV_positionControl} = \"ModulatingControl\" or {MV_positionControl} = \"ModbusRtuControl\"",
              "title": "Power supply",
              "isRequired": true,
              "choices": [
                {
                  "value": "24_24-Voltage^DirectCurrent",
                  "text": "24V DC"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "MV_actuatorPower",
              "visibleIf": "{MV_positionControl} = \"ThreePointControl\"",
              "title": "Power supply",
              "isRequired": true,
              "choices": [
                {
                  "value": "230_230-Voltage^AlternatingCurrent",
                  "text": "230V AC"
                },
                {
                  "value": "24_24-Voltage^DirectCurrent",
                  "text": "24V DC"
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "MV_modulationSignal",
              "visibleIf": "{MV_positionControl} = \"ModulatingControl\"",
              "title": "Modulating signal",
              "isRequired": true,
              "choices": [
                {
                  "value": "0_10-Voltage^DirectCurrent",
                  "text": "0-10 V"
                },
                {
                  "value": "0.5_10-Voltage^DirectCurrent",
                  "text": "0.5-10 V"
                },
                {
                  "value": "2_10-Voltage^DirectCurrent",
                  "text": "2-10 V"
                }
              ]
            },
            {
              "type": "boolean",
              "name": "SP_present",
              "visibleIf": "{MV_actuatorPower} = \"24_24-Voltage^DirectCurrent\" and {MV_positionControl} != \"ModbusRtuControl\"",
              "title": "Motor valve feedback sensor available?",
              "isRequired": true,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "dropdown",
              "name": "MV_controlValveFeedbackType",
              "visibleIf": "{SP_present} = true and {MV_positionControl} != \"ModbusRtuControl\"",
              "title": "Feedback signal",
              "isRequired": true,
              "choices": [
                {
                  "value": "0cl_10-Voltage^DirectCurrent",
                  "text": "0-10 V"
                },
                {
                  "value": "2cl_10-Voltage^DirectCurrent",
                  "text": "2-10 V"
                }
              ]
            },
            {
              "type": "boolean",
              "name": "MV_overrideDefaultValveTravelTime",
              "visibleIf": "{MV_positionControl} = \"ThreePointControl\"",
              "title": "Override default valve travel time (120s)?",
              "isRequired": false,
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "text",
              "name": "ValveTravelTime",
              "visibleIf": "{MV_positionControl} = \"ThreePointControl\" and {MV_overrideDefaultValveTravelTime} = true",
              "title": "How fast does the valve travel from one extreme position to the other (full travel) in seconds?",
              "isRequired": true,
              "inputType": "number",
              "placeHolder": "Travel time in seconds",
              "unit": "s",
              "validators": [
                {
                  "type": "numeric",
                  "minValue": 30,
                  "maxValue": 600
                }
              ]
            },
            {
              "type": "dropdown",
              "name": "MV_valveLocation",
              "title": "Location",
              "isRequired": true,
              "choices": [
                {
                  "value": "PrimaryForward",
                  "text": "Flow pipe"
                },
                {
                  "value": "PrimaryReturn",
                  "text": "Return pipe"
                }
              ]
            }
          ],
          "visibleIf": "{Control_enabled} = true",
          "title": "Control Valve and Actuator"
        }
      ]
    }
  ]
}